import { COLOR_PALETTE } from 'constants/ui';

export const MISMO_FORM_FIELD = 'mismo';

export const ACCEPTED_FILE_TYPES = ['text/xml', 'application/xml', 'text/plain'];

export const PreviewResultType = {
  SUCCESS: 'Success',
  FAIL: 'Fail',
};

export const MismoChangeType = {
  ADDED: 'Added',
  UPDATED: 'Updated',
  REMOVED: 'Removed',
};

const BADGE_TEXT_SHADE = { LIGHT: 8, DARK: 3 };
const BADGE_BACKGROUND_SHADE = { LIGHT: 1, DARK: 10 };

export const MismoChangeBadgeConfig = {
  [MismoChangeType.ADDED]: {
    label: 'Added',
    color: ({ palette }) =>
      COLOR_PALETTE.GREEN[palette.mode === 'dark' ? BADGE_TEXT_SHADE.DARK : BADGE_TEXT_SHADE.LIGHT],
    backgroundColor: ({ palette }) =>
      COLOR_PALETTE.GREEN[
        palette.mode === 'dark' ? BADGE_BACKGROUND_SHADE.DARK : BADGE_BACKGROUND_SHADE.LIGHT
      ],
  },
  [MismoChangeType.UPDATED]: {
    label: 'Updated',
    color: ({ palette }) =>
      COLOR_PALETTE.ORANGE[
        palette.mode === 'dark' ? BADGE_TEXT_SHADE.DARK : BADGE_TEXT_SHADE.LIGHT
      ],
    backgroundColor: ({ palette }) =>
      COLOR_PALETTE.ORANGE[
        palette.mode === 'dark' ? BADGE_BACKGROUND_SHADE.DARK : BADGE_BACKGROUND_SHADE.LIGHT
      ],
  },
  [MismoChangeType.REMOVED]: {
    label: 'Removed',
    color: ({ palette }) =>
      COLOR_PALETTE.RED[palette.mode === 'dark' ? BADGE_TEXT_SHADE.DARK : BADGE_TEXT_SHADE.LIGHT],
    backgroundColor: ({ palette }) =>
      COLOR_PALETTE.RED[
        palette.mode === 'dark' ? BADGE_BACKGROUND_SHADE.DARK : BADGE_BACKGROUND_SHADE.LIGHT
      ],
  },
};

export const UPLOAD_CTA_MESSAGE = 'Upload a MISMO 3.4 file';

export const PREVIEW_FAILED_MESSAGE =
  'Failed to read the MISMO file. Please check the file and try again.';

export const NO_CHANGES_MESSAGE = 'No changes were found in the file. You can still proceed.';

export const EMPTY_VALUE_PLACEHOLDER = '—';
